// Medical Records Release Service for saving authorization data

const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:3001';
  return '';
};

export const saveRecordsReleaseAuth = async (authPayload) => {
  try {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/records-release`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(authPayload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to save records release authorization');
    return { success: true, ...data };
  } catch (err) {
    console.error('RecordsReleaseService.saveRecordsReleaseAuth error:', err);
    return { success: false, error: err.message };
  }
};

export const sendRecordsReleaseEmail = async (authPayload) => {
  try {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/records-release/send-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(authPayload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to send authorization email');
    return { success: true, ...data };
  } catch (err) {
    console.error('RecordsReleaseService.sendRecordsReleaseEmail error:', err);
    return { success: false, error: err.message };
  }
};
